import getRollLength from 'editor/src/store/gangSheet/selector/getRollLength';
import { RootState } from 'editor/src/store/index';

import { getFilmFill, isGangSheetProductUid, PageFill } from 'editor/src/util/gangSheet/isGangSheetProductUid';

// A length range arrives only for a product the printer marked as a growing gang sheet,
// so unlike the builder setting it identifies the product, whatever its uid.
const getEmptyPageDisplayFill = (state: RootState): PageFill | undefined =>
  getRollLength(state) || isGangSheetProductUid(state.design.designData?.product_uid) ? getFilmFill() : undefined;

export default getEmptyPageDisplayFill;
